import { connect } from 'react-redux'
import at from 'lodash/at'
import get from 'lodash/get'
import filter from 'lodash/filter'
import { replace } from 'react-router-redux'

import { loadIssuesForLocation, downloadCSV } from '../../actions/issues'
import { fetchLocation } from '../../actions/locations'
import { resetCurrentFilter } from '../../actions/areas'

import {
  needsWorkSelector,
  needsReviewSelector,
  permanentSelector,
  resolvedSelector
} from '../../selectors/issue-selectors'

import IssuesList from '../../components/issues/issues-list'

function mapStateToProps (state, ownProps) {
  const pagination = get(state, `pagination.issuesByLocation.${ownProps.params.locationId}`, {})
  const location = get(state, `locations.${ownProps.params.locationId}`)
  const needsWorkIssueCount = get(location, 'needsWorkIssueCount', 0)
  const needsReviewIssueCount = get(location, 'needsReviewIssueCount', 0)
  const permanentIssueCount = get(location, 'permanentIssueCount', 0)
  let allowFiltering = true
  let issuesForArea = false
  let filteredArea = null

  if (ownProps.location.query.hasOwnProperty('allow_filtering')) {
    // The "~~" converts it to an Int, the "!" makes it a Boolean
    allowFiltering = !~~ownProps.location.query.allow_filtering
    issuesForArea = true
  }

  if (state.areas.hasOwnProperty('currentFilter')) {
    const area = state.areas[state.areas.currentFilter]
    filteredArea = area ? area.name : ''
  }

  return {
    needsWork: needsWorkSelector(state, "issuesByLocation", ownProps.params.locationId),
    needsReview: needsReviewSelector(state, "issuesByLocation", ownProps.params.locationId),
    permanent: permanentSelector(state, "issuesByLocation", ownProps.params.locationId),
    resolved: resolvedSelector(state, "issuesByLocation", ownProps.params.locationId),
    hasNextPage: pagination.nextPageUrl,
    allowFiltering,
    issuesForArea,
    filteredArea,
    needsWorkIssueCount,
    needsReviewIssueCount,
    permanentIssueCount
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  dispatch(fetchLocation(ownProps.params.locationId))
    .then(() => dispatch(loadIssuesForLocation(ownProps.params.locationId)))

  return {
    csvDownload () {
      dispatch(downloadCSV(ownProps.params.locationId))
    },

    onLoadNextPage () {
      dispatch(loadIssuesForLocation(ownProps.params.locationId, true))
    },

    viewAllIssuesClicked () {
      dispatch(resetCurrentFilter())
      dispatch(replace(`location-issues/${ownProps.params.locationId}`))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(IssuesList)



// WEBPACK FOOTER //
// ./src/containers/issues/location-issues-list-container.js